import App from './ProjectApp';

// Automatic icon imports for icon spritesheet
(function (r) { r.keys().forEach(r); })(require.context('$icons/', true, /\.svg$/));

// application run and take care of drupal integration
function init () {
    if (window['app']) {
        window.app.refresh();
    }
    else {
        window.app = new App();
    }
}

(function (Drupal) {
    Drupal.behaviors.minskyBehavior = {
        // attach (context, settings) {
        attach () {
            if (document.readyState === 'complete') {
                init();
            }
            else {
                window.addEventListener('DOMContentLoaded', init);
            }
        },
    };
})(Drupal);
